// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper_mobile":"mobileform-module--form_wrapper_mobile--2a6Tj"};